export const appendParms = (url: string): string => {
  const urlObj = new URL(url);

  const isYoutubeHost = urlObj.hostname.includes('youtube');

  if (isYoutubeHost && !urlObj.searchParams.has('rel')) {
    urlObj.searchParams.append('rel', '0');
  }

  return urlObj.toString();
};

export const addLazyLoadToIframes = (htmlString: string) => {
  const scriptSrcRegex = /<script(.*?)><\/script>/g;
  const iframeSrcRegex = /<iframe(.*?)><\/iframe>/g;

  const addLoadingToIframe = (_match: string, attributes: string) =>
    `<iframe${attributes} loading="lazy" scrolling="no"></iframe>`;

  const modifiedHtmlWithoutScript = htmlString.replace(scriptSrcRegex, '');
  const modifiedHtmlWithIframe = modifiedHtmlWithoutScript.replace(iframeSrcRegex, addLoadingToIframe);

  return modifiedHtmlWithIframe;
};

export function getScriptTags(htmlContent: string) {
  const regex = /<script\b[^>]*\ssrc=(['"])(.*?)\1[^>]*>/gm;
  const srcValues = [];
  let match = regex.exec(htmlContent);

  while (match !== null) {
    const matchedValue = match[2];
    if (matchedValue) {
      srcValues.push(matchedValue);
    }
    match = regex.exec(htmlContent);
  }
  return srcValues;
}
